<template>
    <el-card>
        <div slot="header" class="clearfix">
            <el-row type="flex" align="middle">
                <el-col class="card-heading">Test Audio</el-col>
                <el-col>
                    <el-button
                        class="test-button"
                        @click="recordAndPlay($event)"
                        :disabled="isButtonDisabled"
                        >Play</el-button
                    >
                </el-col>
            </el-row>
        </div>
        <el-row
            align="middle"
            justify="space-between"
            type="flex"
            v-if="audioDevices.length"
        >
            <el-col class="result-heading">
                <el-select
                    v-model="selectedDevice"
                    placeholder="Select audio device"
                >
                    <el-option
                        v-for="device in audioDevices"
                        :key="device.deviceId"
                        :value="device.deviceId"
                        :label="device.label"
                    >
                    </el-option>
                </el-select>
            </el-col>
            <el-col :offset="2" :span="6">
                <split-progress-bar
                    :value="vol"
                    :maxValue="peakVol"
                    class="progress"
                />
            </el-col>
        </el-row>
        <status-content v-if="audioDevices.length==0" :content="error" />
    </el-card>
</template>

<script>
import { mapState } from 'vuex';
import SplitProgressBar from './SplitProgressBar';
import StatusContent from './StatusContent.vue';

const PLAY_TEXT = 'Play';
const RECORDING_TEXT = 'Recording';
const PLAYING_TEXT = 'Playing';

export default {
    name: 'AudioCheck',
    components: {
        StatusContent,
        SplitProgressBar
    },
    data: function() {
        return {
            isRecording: false,
            recorder: null,
            peakVol: 1,
            vol: 0,
            isButtonDisabled: false,
            labels: {
                playText: 'Play',
            },
            recordTime: 3000,
        };
    },
    computed: {
        ...mapState({
            audioDevices: (state) => state.devices.audioDevices,
            error: (state)=>state.devices.audioError
        }),
        selectedDevice: {
            get() {
                return this.$store.state.devices.selectedAudioDevice;
            },
            set(value) {
                this.$store.commit('devices/setSelectedAudioDevice', value);
            },
        },
    },
    methods: {
        async recordAndPlay(event) {
            try {
                // validate Devices and select devices
                this.$store.commit('devices/setAudioDevices',{audio:true});
                this.recorder = await this.recordAudio(this.selectedDevice);
                this.recorder.start();
                event.target.innerText = RECORDING_TEXT;
                this.isButtonDisabled = true;
                setTimeout(() => {
                    this.stopRecording(this.recorder, event.target);
                }, this.recordTime);
            } catch (error) {
                console.log(error);
            }
        },
        async stopRecording(recorder, target) {
            const audio = await recorder.stop();
            target.innerText = PLAYING_TEXT;
            audio.play();
            setTimeout(() => {
                this.isButtonDisabled = false;
                target.innerText = PLAY_TEXT;
            }, this.recordTime);
        },
        async recordAudio(selectedDevice) {
            let audioMedia = await navigator.mediaDevices.getUserMedia({
                audio: true,
                deviceId: {
                    exact: selectedDevice,
                },
            });
            let audioContext = new AudioContext();
            let jsNode = audioContext.createScriptProcessor(2048, 1, 1);
            const mediaRecorder = new MediaRecorder(audioMedia);
            const audioChunks = [];
            mediaRecorder.addEventListener('dataavailable', (event) => {
                audioChunks.push(event.data);
            });
            const start = () => {
                this.analyzeAudio(audioMedia, audioContext, jsNode);
                mediaRecorder.start();
            };
            const stop = async () => {
                return new Promise((resolve) => {
                    mediaRecorder.addEventListener('stop', () => {
                        const audioBlob = new Blob(audioChunks);
                        const audioUrl = URL.createObjectURL(audioBlob);
                        const audio = new Audio(audioUrl);
                        mediaRecorder.removeEventListener('stop', () => {});
                        resolve(audio);
                    });
                    mediaRecorder.stop();
                    jsNode.removeEventListener('audioprocess', () => {});
                    audioMedia.getAudioTracks().forEach((track) => {
                        track.stop();
                    });
                });
            };
            return { start, stop };
        },
        analyzeAudio(audioStream, audioContext, jsNode) {
            let analyzer = audioContext.createAnalyser();
            let mic = audioContext.createMediaStreamSource(audioStream);
            analyzer.fftSize = 1024;
            mic.connect(analyzer);
            analyzer.connect(jsNode);
            jsNode.connect(audioContext.destination);
            this.vol = 0;
            this.peakVol = 1;
            jsNode.addEventListener('audioprocess', () => {
                let dataArray = new Uint8Array(analyzer.frequencyBinCount);
                analyzer.getByteFrequencyData(dataArray);
                this.vol = this.getRMS(dataArray);
                if (this.vol > this.peakVol) {
                    this.peakVol = this.vol;
                }
            });
        },

        getRMS(dataArray) {
            let sqrVal = dataArray.reduce((acc, val) => acc + val * val);
            return Math.sqrt(sqrVal / dataArray.length);
        },
    },
};
</script>

<style scoped>
.progress {
    height: 30px;
}
.el-select {
    width: 100%;
}
.el-icon {
    font-size: 30px;
}
.el-icon-error {
    color: #d32f2f;
}
.el-icon-warning {
    color: rgb(255, 102, 0);
}
div.result-heading,
div.card-heading {
    text-align: left;
}
.test-button {
    float: right;
}
</style>
